import { useParams } from "react-router-dom"

import { PropTypes } from "@l2r-front/l2r-proptypes"

import { RoadworkDetailsInfo, RoadworkDetailsError, RoadworkDetailsSkeleton } from "../../components/RoadworkDetailsInfo"
import { useRoadworksStateContext } from "../../contexts/RoadworksContext"
import { useRoadworkWithTasks } from "../../hooks/queries/useRoadwork"
import { useTaskTypes } from "../../hooks/queries/useTaskType"

export function RoadworkDetails(props) {

    const {
        className,
    } = props

    const { road, roadworkUuid } = useParams()
    const {
        data: roadwork,
        isLoading: isLoadingRoadwork,
        isError: isErrorRoadwork,
    } = useRoadworkWithTasks(roadworkUuid, road)
    const { currency } = useRoadworksStateContext()
    const {
        data: taskTypes,
        isLoading: isLoadingTaskTypes,
        isError: isErrorTaskTypes,
    } = useTaskTypes()

    if (isLoadingRoadwork || isLoadingTaskTypes) {
        return <RoadworkDetailsSkeleton />
    }

    if (isErrorRoadwork || isErrorTaskTypes) {
        return <RoadworkDetailsError />
    }

    return <RoadworkDetailsInfo
        className={className}
        currency={currency}
        roadwork={roadwork}
        taskTypes={taskTypes}
    />
}

RoadworkDetails.propTypes = {
    className: PropTypes.string,
    currency: PropTypes.string.isRequired,
    hasPendingChange: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    initialState: PropTypes.roadworkForm.isRequired,
    roadwork: PropTypes.roadworkWithTasks.isRequired,
    taskTypes: PropTypes.arrayOf(PropTypes.taskType).isRequired,
}